import { SpecificSearchToneDto } from '../../../dto/specificsearchtone/specificsearchtonedto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface SpecificSearchToneRequest extends APIRequest
{
    getSpecificSearchToneRequest(): SpecificSearchToneDto;
}

export class SpecificSearchToneRequestImpl extends APIRequestDtoImpl implements SpecificSearchToneRequest
{
    constructor(private specificSearchToneData: SpecificSearchToneDto)
    {
        super();
    }

    getSpecificSearchToneRequest(): SpecificSearchToneDto
    {
        return this.specificSearchToneData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/search/specificsearchtone/specificsearchtonerequest.tsx